export default {
  namespaced: true,
  state: {
    errors: [],
    hasMissingRights: false
  },
  mutations: {
    addError(state, error) {
      state.errors.push(error);
    },
    clear(state) {
      state.errors = [];
    },
    removeError(state, error) {
      const index = state.errors.indexOf(error);
      state.errors.splice(index, 1);
    },
    missingRights(state, value) {
      state.hasMissingRights = value;
    }
  },
  actions: {
    addError({commit}, error) {
      commit('addError', error)
    },
    clear({commit}) {
      commit('clear');
    },
    missingRights({commit}, {value}) {
      commit('missingRights', value);
    },
    removeError({commit}, error) {
      commit('removeError', error)
    }
  }
}
